if (!customElements.get("alert-message")) {
  class alertMessage extends HTMLElement {
    constructor() {
      super(),
        (this.closeButton = this.querySelector(".js-close-message")),
        (this.openInEditor = !1),
        this.init(),
        this.bindEvents();
    }
    disconnectedCallback() {
      this.blockSelectHandler &&
        document.removeEventListener(
          "shopify:block:select",
          this.blockSelectHandler
        ),
        this.blockDeselectHandler &&
          document.removeEventListener(
            "shopify:block:deselect",
            this.blockDeselectHandler
          );
    }
    init() {
      let preventShow = !1;
      if (this.dataset.persistentClose && !Shopify.designMode) {
        const closedMessages =
          theme.storageUtil.get("closed-messages", !0) || [];
        closedMessages &&
          closedMessages.includes(this.dataset.blockId) &&
          ((preventShow = !0), this.remove());
      }
      this.classList.contains("alert-message--out") &&
        (!preventShow || Shopify.designMode) &&
        (this.show(!this.dataset.transient),
        this.dataset.transient &&
          setTimeout(() => {
            this.openInEditor || this.hide(!1);
          }, this.dataset.transient * 1e3));
    }
    bindEvents() {
      this.closeButton &&
        this.closeButton.addEventListener(
          "click",
          this.handleCloseClick.bind(this)
        ),
        Shopify.designMode &&
          this.dataset.transient &&
          ((this.blockSelectHandler = this.handleBlockSelect.bind(this)),
          (this.blockDeselectHandler = this.handleBlockDeselect.bind(this)),
          document.addEventListener(
            "shopify:block:select",
            this.blockSelectHandler
          ),
          document.addEventListener(
            "shopify:block:deselect",
            this.blockDeselectHandler
          ));
    }
    handleBlockSelect(evt) {
      evt.target.classList.contains("alert-message") &&
        evt.target.dataset.transient &&
        ((this.openInEditor = !0), this.show(!0));
    }
    handleBlockDeselect(evt) {
      evt.target.classList.contains("alert-message") &&
        evt.target.dataset.transient &&
        ((this.openInEditor = !1),
        this.hide(!0),
        theme.storageUtil.remove("closed-messages"));
    }
    handleCloseClick() {
      if (this.dataset.persistentClose) {
        const closedMessages =
          theme.storageUtil.get("closed-messages", !0) || [];
        closedMessages.includes(this.dataset.blockId) ||
          (closedMessages.push(this.dataset.blockId),
          theme.storageUtil.set("closed-messages", closedMessages));
      }
      this.hide(!0);
    }
    show(instant) {
      instant &&
        ((this.style.transitionDelay = "0s"),
        (this.style.transitionDuration = "0s")),
        this.classList.remove("alert-message--out");
    }
    hide(instant) {
      instant &&
        ((this.style.transitionDelay = "0s"),
        (this.style.transitionDuration = "0.2s"),
        (this.style.filter = "opacity(0)"),
        (this.style.pointerEvents = "none")),
        this.classList.contains("alert-message--info")
          ? ((this.style.maxHeight = `${
              this.getBoundingClientRect().height + 10
            }px`),
            setTimeout(() => {
              this.classList.add("alert-message--out");
            }))
          : this.classList.add("alert-message--out");
    }
  }
  customElements.define("alert-message", alertMessage);
}
